import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../../../services/security';
import { CookieService } from 'ngx-cookie-service';
import { AppConsts } from '../../../shared/app-consts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu-v2.component.html',
  styleUrls: ['./nav-menu.component.css', './nav-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class NavMenuComponent implements OnInit {
  slidMenuVisible = false;
  accountMenuVisible = false;
  userName: string = null;
  currentEmail: string;
  settingMenuVisible = false;
  fullName: string;

  constructor(private router: Router, private authService: AuthenticationService,
    private cookieService: CookieService) { }

  ngOnInit() {
    this.authService.authenticationState.subscribe(() => {
      this.loadConnectedUser();
    });
  }

  loadConnectedUser() {
    if (this.authService.IsAuthenticated()) {
      var jwtToken = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
      this.userName = jwtToken.UserName;
      this.fullName = jwtToken.FullName;
      this.currentEmail = sessionStorage.getItem(AppConsts.USER_MAIL);
    }
  }

  showSideBar() {
    this.slidMenuVisible = true;
  }

  showAccountMenu() {
    this.accountMenuVisible = true;
  } 
  showSettingBar(){
    this.settingMenuVisible = true;
  }

  onSideBarClose() {
    this.slidMenuVisible = false;
  }

  onSettingBarClose() {
    this.settingMenuVisible = false;
  }
}
